import { getComputedCssVariableValue } from '@utils/ui'

/**
 * Shorthand for getting a computed CSS variable value in hex
 * Note: specifically need to convert to sRGB first to get the hex value
 * 
 * @param {string} variableName For example `--b1`
 * @returns {string}
 */
// noinspection JSCheckFunctionSignatures
const getComputedHex = variableName => getComputedCssVariableValue(variableName)
    .to('srgb').toString({ format: 'hex' })

export const stripeConfigs = {
    
    addressElementOpts: {
        mode: 'billing',
        allowedCountries: ['US'],
    },
    
    paymentElementOpts: {
        fields: {
            billingDetails: {
                name: 'auto',
                email: 'auto',
                phone: 'auto',
                address: 'auto',
            },
        },
        wallets: location.protocol === 'https:' ? {
            applePay: 'auto',
            googlePay: 'auto',
        } : {},
    },
    
    // For theming Stripe Elements
    getStripeElementsOptions: () => {
        
        // Primary color here is actually the accent color for form borders, etc.
        const colorPrimary = getComputedHex('--a')
        const colorBackground = getComputedHex('--b1')
        const colorText = getComputedHex('--bc')
        
        return {
            appearance: {
                // https://stripe.com/docs/elements/appearance-api#theme
                theme: 'stripe', // 'stripe', 'flat', 'night'
                variables: {
                    colorPrimary,
                    colorBackground,
                    colorText,
                    fontSizeBase: '0.95rem',
                },
                labels: 'floating',
            },
        }
        
    },
    
}
